import { h } from 'preact'
import Icon from '../assets'

export const InformationCallout = ({ text }: { text: string }) => (
  <div className='panel-form-information'>
    <div><Icon icon={'info'} customClass='icon-info' /></div>
    <div className='panel-form-info-text'>{text}</div>
  </div>
)
